import BasePerimeter from './basePerimeter';

export default new BasePerimeter({
  purpose: 'categories',
  govern: {
    'can route': function route() {
      return this.isAdmin();
    },
    'can editCategories': function editCategories() {
      return this.isAdmin();
    },
  },
});



// WEBPACK FOOTER //
// ./src/perimeters/categoriesPerimeter.js